import React from 'react';
import './style.css'
import TravelCard from "./TravelCard";
import Property1ActiveRight from "./Property1ActiveRight";


const Comp3 = () =>{
    return (
        <div className="frame-parent2">
          <div className="frame-parent3">
            <div className="choose-your-next-destination-parent">
              <div className="choose-your-next">choose your next destination</div>
              <div className="explore-top-destination">Explore top destination</div>
            </div>
            <div className="instance-parent">
              <Property1ActiveRight
                dimensions="./img/-icon-nav-arrow-right2.svg"
                property1ActiveRightBoxShadow="0px 178.5px 50.29px rgba(0, 0, 0, 0), 0px 114.4px 45.36px rgba(0, 0, 0, 0.01), 0px 64.1px 38.46px rgba(0, 0, 0, 0.04), 0px 28.6px 28.6px rgba(0, 0, 0, 0.06), 0px 6.9px 15.78px rgba(0, 0, 0, 0.07), 0px 0px 0px rgba(0, 0, 0, 0.08)"
                property1ActiveRightPosition="relative"
                rectangleDivBackgroundColor="#f7f6f6"
                iconNavArrowRightHeight="38.48%"
                iconNavArrowRightWidth="22.41%"
                iconNavArrowRightTop="30.87%"
                iconNavArrowRightRight="38.69%"
                iconNavArrowRightBottom="30.66%"
                iconNavArrowRightLeft="38.9%"
              />
              <Property1ActiveRight
                dimensions="./img/-icon-nav-arrow-right3.svg"
                property1ActiveRightBoxShadow="0px 178.5px 50.29px rgba(0, 0, 0, 0), 0px 114.4px 45.36px rgba(0, 0, 0, 0.01), 0px 64.1px 38.46px rgba(0, 0, 0, 0.04), 0px 28.6px 28.6px rgba(0, 0, 0, 0.06), 0px 6.9px 15.78px rgba(0, 0, 0, 0.07), 0px 0px 0px rgba(0, 0, 0, 0.08)"
                property1ActiveRightPosition="relative"
                rectangleDivBackgroundColor="#5d50c6"
                iconNavArrowRightHeight="38.48%"
                iconNavArrowRightWidth="22.41%"
                iconNavArrowRightTop="30.87%"
                iconNavArrowRightRight="35.52%"
                iconNavArrowRightBottom="30.66%"
                iconNavArrowRightLeft="42.07%"
              />
            </div>
          </div>
          <div className="travel-card-parent">
            <TravelCard
              imageDimensions="./img/rectangle-14362.svg"
              imageDimensionsText="./img/rectangle-14363.svg"
              imageDimensionsText2="./img/rectangle-3301.svg"
              priceText="$380"
              locationText="Machu Picchu, Peru"
              locationDescription="Cappadocia"
              imageDimensionsText3="./img/rectangle-14351@2x.png"
              imageDimensionsText4="./img/rectangle-14341@2x.png"
              imageDimensions2="./img/star1.svg"
              travelCardWidth="385.6px"
              travelCardHeight="516.7px"
              travelCardPosition="relative"
              groupDivTop="274.5px"
              groupDivWidth="385.6px"
              groupDivHeight="231.3px"
              rectangleIconTop="81.9px"
              rectangleIconWidth="385.6px"
              rectangleIconHeight="149.4px"
              rectangleIconWidth1="385.6px"
              rectangleIconHeight1="138.8px"
              rectangleIconTop1="137.8px"
              rectangleIconLeft="234.2px"
              rectangleIconBorderRadius="96.39px"
              rectangleIconWidth2="151.3px"
              rectangleIconHeight2="99.3px"
              groupDivTop1="150.4px"
              groupDivWidth1="335.7px"
              groupDivWidth2="335.7px"
              groupDivWidth3="172.5px"
              frameDivWidth="172.5px"
              frameDivLeft="236.2px"
              groupDivTop2="293.8px"
              groupDivWidth4="335.4px"
              groupDivHeight1="94.6px"
              groupDivWidth5="335.4px"
              groupDivHeight2="94.6px"
              groupDivWidth6="335.4px"
              groupDivHeight3="94.6px"
              loremIpsumIsWidth="335.4px"
              rectangleIconWidth3="385.6px"
              rectangleIconHeight3="330.4px"
              rectangleIconWidth4="385.6px"
              rectangleIconHeight4="273.8px"
              ellipseDivTop="-83.1px"
              ellipseDivLeft="-81.9px"
              ellipseDivFilter="blur(86.75px)"
              ellipseDivWidth="190.9px"
              ellipseDivHeight="190.9px"
              frameDivLeft1="267px"
              frameDivBoxShadow="6.7px 0px 19.28px rgba(255, 255, 255, 0.15) inset"
              frameDivBackdropFilter="blur(7.71px)"
              frameDivWidth1="90.6px"
              frameDivPadding="5.783535957336426px 13.494917869567871px 5.783535957336426px 5.783535957336426px"
              frameDivBoxShadow1="6.7px 0px 19.28px rgba(255, 255, 255, 0.15) inset, 3.9px 7.7px 19.28px rgba(0, 0, 0, 0.15)"
            />
            <TravelCard
              imageDimensions="./img/rectangle-14362.svg"
              imageDimensionsText="./img/rectangle-14363.svg"
              imageDimensionsText2="./img/rectangle-3301.svg"
              priceText="$300"
              locationText="French Riviera, France"
              locationDescription="Nice and Cannes"
              imageDimensionsText3="./img/rectangle-14352@2x.png"
              imageDimensionsText4="./img/rectangle-14342@2x.png"
              imageDimensions2="./img/star1.svg"
              travelCardWidth="385.6px"
              travelCardHeight="516.7px"
              travelCardPosition="relative"
              groupDivTop="274.5px"
              groupDivWidth="385.6px"
              groupDivHeight="231.3px"
              rectangleIconTop="81.9px"
              rectangleIconWidth="385.6px"
              rectangleIconHeight="149.4px"
              rectangleIconWidth1="385.6px"
              rectangleIconHeight1="138.8px"
              rectangleIconTop1="137.8px"
              rectangleIconLeft="234.2px"
              rectangleIconBorderRadius="96.39px"
              rectangleIconWidth2="151.3px"
              rectangleIconHeight2="99.3px"
              groupDivTop1="150.4px"
              groupDivWidth1="335.7px"
              groupDivWidth2="335.7px"
              groupDivWidth3="172.5px"
              frameDivWidth="172.5px"
              frameDivLeft="236.2px"
              groupDivTop2="293.8px"
              groupDivWidth4="335.4px"
              groupDivHeight1="94.6px"
              groupDivWidth5="335.4px"
              groupDivHeight2="94.6px"
              groupDivWidth6="335.4px"
              groupDivHeight3="94.6px"
              loremIpsumIsWidth="335.4px"
              rectangleIconWidth3="385.6px"
              rectangleIconHeight3="330.4px"
              rectangleIconWidth4="385.6px"
              rectangleIconHeight4="273.8px"
              ellipseDivTop="-83.1px"
              ellipseDivLeft="-81.9px"
              ellipseDivFilter="blur(86.75px)"
              ellipseDivWidth="190.9px"
              ellipseDivHeight="190.9px"
              frameDivLeft1="267px"
              frameDivBoxShadow="6.7px 0px 19.28px rgba(255, 255, 255, 0.15) inset"
              frameDivBackdropFilter="blur(7.71px)"
              frameDivWidth1="90.6px"
              frameDivPadding="5.783535957336426px 13.494917869567871px 5.783535957336426px 5.783535957336426px"
              frameDivBoxShadow1="6.7px 0px 19.28px rgba(255, 255, 255, 0.15) inset, 3.9px 7.7px 19.28px rgba(0, 0, 0, 0.15)"
            />
            <TravelCard
              imageDimensions="./img/rectangle-14362.svg"
              imageDimensionsText="./img/rectangle-14363.svg"
              imageDimensionsText2="./img/rectangle-3301.svg"
              priceText="$200"
              locationText="Seville, Spain"
              locationDescription="Seville"
              imageDimensionsText3="./img/rectangle-14353@2x.png"
              imageDimensionsText4="./img/rectangle-14343@2x.png"
              imageDimensions2="./img/star1.svg"
              travelCardWidth="385.6px"
              travelCardHeight="516.7px"
              travelCardPosition="relative"
              groupDivTop="274.5px"
              groupDivWidth="385.6px"
              groupDivHeight="231.3px"
              rectangleIconTop="81.9px"
              rectangleIconWidth="385.6px"
              rectangleIconHeight="149.4px"
              rectangleIconWidth1="385.6px"
              rectangleIconHeight1="138.8px"
              rectangleIconTop1="137.8px"
              rectangleIconLeft="234.2px"
              rectangleIconBorderRadius="96.39px"
              rectangleIconWidth2="151.3px"
              rectangleIconHeight2="99.3px"
              groupDivTop1="150.4px"
              groupDivWidth1="335.7px"
              groupDivWidth2="335.7px"
              groupDivWidth3="172.5px"
              frameDivWidth="172.5px"
              frameDivLeft="236.2px"
              groupDivTop2="293.8px"
              groupDivWidth4="335.4px"
              groupDivHeight1="94.6px"
              groupDivWidth5="335.4px"
              groupDivHeight2="94.6px"
              groupDivWidth6="335.4px"
              groupDivHeight3="94.6px"
              loremIpsumIsWidth="335.4px"
              rectangleIconWidth3="385.6px"
              rectangleIconHeight3="330.4px"
              rectangleIconWidth4="385.6px"
              rectangleIconHeight4="273.8px"
              ellipseDivTop="-83.1px"
              ellipseDivLeft="-81.9px"
              ellipseDivFilter="blur(86.75px)"
              ellipseDivWidth="190.9px"
              ellipseDivHeight="190.9px"
              frameDivLeft1="267px"
              frameDivBoxShadow="6.7px 0px 19.28px rgba(255, 255, 255, 0.15) inset"
              frameDivBackdropFilter="blur(7.71px)"
              frameDivWidth1="90.6px"
              frameDivPadding="5.783535957336426px 13.494917869567871px 5.783535957336426px 5.783535957336426px"
              frameDivBoxShadow1="6.7px 0px 19.28px rgba(255, 255, 255, 0.15) inset, 3.9px 7.7px 19.28px rgba(0, 0, 0, 0.15)"
            />
          </div>
        </div>
      );
    };

export default Comp3;